/* Mahalle — product-card quantity stepper (UX audit #9)
   Makes the hidden quantity input on single-variant cards adjustable with +/-.
   Self-contained: injects its own CSS once and uses one delegated listener.
   Does NOT touch the add-to-cart mechanism — the form still posts name="quantity". */
(function () {
  if (window.__cardQtyInit) return;
  window.__cardQtyInit = true;

  var css =
    '.card-qty{display:inline-flex;align-items:center;border:1px solid #e3d8e1;border-radius:8px;overflow:hidden;height:36px;margin:0 0 8px;background:#fff;vertical-align:middle;}' +
    '.card-qty__btn{appearance:none;-webkit-appearance:none;border:0;background:transparent;width:32px;height:34px;font-size:18px;line-height:1;cursor:pointer;color:#86206e;font-weight:600;display:flex;align-items:center;justify-content:center;padding:0;}' +
    '.card-qty__btn:hover{background:#faf3f8;}' +
    '.card-qty__input{width:38px;height:34px;border:0;text-align:center;font-size:14px;font-weight:600;color:#232323;background:transparent;-moz-appearance:textfield;}' +
    '.card-qty__input::-webkit-outer-spin-button,.card-qty__input::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none;display:none;margin:0;}';
  var st = document.createElement('style');
  st.id = 'card-qty-style';
  st.textContent = css;
  document.head.appendChild(st);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-qty-minus],[data-qty-plus]') : null;
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.card-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('card-qty__input')) {
      var v = parseInt(t.value, 10);
      if (isNaN(v) || v < 1) t.value = 1;
    }
  });
})();
